class DataSource {
  constructor (code, name, resolution, description, color) {
    this.code = code
    this.name = name // filled by the backend but used for translation
    this.resolution = resolution
    this.description = description // filled by the backend but used for translation
    this.boundingPolygon = [] // filled by the backend
    this.color = color // used in the map
  }
}

const $gettext = s => s // for easygettext to peek translations

const dataSources = [
  new DataSource(
    'AFR',
    $gettext('Copernicus AFR'),
    '50 km',
    $gettext('Domain dataset for Africa zone. 21 AFR-CORDEX models for RCP 4.5 and 31 for RCP 8.5.'),
    '#2C7FB8', // blue
  ),
  new DataSource(
    'AUS',
    $gettext('Copernicus AUS'),
    '50 km',

    $gettext('Domain dataset for Austral Asia zone. 13 AUS-CORDEX models for RCP 4.5 and 22 for RCP 8.5.'),
    '#FEB24C', // yellow
  ),
  new DataSource(
    'EUR_CMIP5',
    $gettext('Copernicus EUR CMIP 5'),
    '1 km',
    $gettext('Domain dataset for Europe zone. 8-10 CMIP 5 models.'),
    '#41B6C4', // turquoise
  ),
  new DataSource(
    'FR',
    $gettext('DRIAS RCP 4.5 and 8.5'),
    '8 km',
    $gettext('Domain dataset for France. 10 models for RCP 4.5 and 12 for RCP 8.5.'),
    '#FD8D3C', // light orange
  ),
  new DataSource(
    'SEA',
    $gettext('Copernicus SEA'),
    '50 km',
    $gettext('Domain dataset for South East Asia zone. 4-5 SEA-CORDEX models for RCP 4.5 and 11-12 for RCP 8.5.'),
    '#A1DAB4', // green
  ),
  new DataSource(
    'TRACC',
    $gettext('DRIAS TRACC'),
    '8 km',
    $gettext('Domain dataset for France, 17 models for TRACC.'),
    '#b92cf5', // purple
  ),
  new DataSource(
    'WAS',
    $gettext('Copernicus WAS'),
    '50 km',
    $gettext('Domain dataset for South Asia zone. 11-19 WAS-CORDEX models for RCP 4.5 and 20-26 for RCP 8.5.'),
    '#BD0026', // red
  ),
  new DataSource(
    'CAN_2025',
    $gettext('ClimateData CA 2025'),
    '7 km',
    $gettext('Domain dataset for Canada, 35 models for SSP2-4.5 , SSP3-7.0 and SSP5-8.5'),
    '#ED1C24', // Canadian flag red
  ),
  new DataSource(
    'CAN',
    $gettext('ClimateData CA'),
    '7 km',
    $gettext('Domain dataset for Canada, 35 models for SSP2-4.5 , SSP3-7.0 and SSP5-8.5'),
    '#ED1C24', // Canadian flag red
  ),
]
const dataSourceMap = new Map(dataSources.map(ds => [ds.code, ds]))
export default dataSourceMap
